import React, {useState, useEffect, useContext} from "react"
import {useQuery, useMutation} from "@apollo/client"

import userGet from "graphql/User/query/userGet"
import userAdd from "graphql/User/mutation/userAdd"

import {alertContext} from "context/Alert/alert"

import './style.scss'

type UserDetailsProps = {
  userId: string | null,
  open?: boolean,
}

export const UserDetails = (props: UserDetailsProps) => {

  const {setMessage, setError} = useContext(alertContext)
  const userAddMutation = useMutation(userAdd)
  const {data} = useQuery(userGet, {
    variables: {
      id: props?.userId
    },
    skip: !props?.userId
  })

  const [open, updateOpen] = useState<boolean>(props?.open ?? false)
  const [formUpdated, updateFormUpdated] = useState<boolean>(false)
  const [user, updateUser] = useState<any>({})

  useEffect(() => {
    updateUser(data?.user)
  }, [data])

  const onChange = (user: any) => {
    updateFormUpdated(true)
    updateUser(user)
  }

  const saveForm = () => {
    if (data?.user?.id) {
      console.log("DOING NOTHING FOR UPDATE")
    } else {
      userAddMutation[0]({
        variables: {
          input: {
            email: user?.email,
          }
        }
      })
      .then(() => setMessage("Utilisateur ajouté"))
      .catch(() => setError("Impossible d'ajouter cet utilisateur"))
    }
  }

  const resetForm = () => {
    updateFormUpdated(false)
    updateUser(data?.user)
  }

  const isExistingUser = !!props.userId

  return (
    <div className={`user-details-container ${isExistingUser ? "existing-user" : "new-user"}`}>
      <div className="card">
        {isExistingUser && (
          <button type="button" className="card-header user-card-summary" onClick={() => updateOpen(!open)} aria-expanded={open}>
            <span className="user-avatar"><span className="fas fa-user"></span></span>
            <span className="user-email">{user?.email || "Chargement…"}</span>
            <span className="user-role">Administrateur</span>
            <span className={`fas fa-chevron-${open ? "up" : "down"}`} aria-hidden="true"></span>
          </button>
        )}
        <div className={open ? "collapse-container collapse-visible" : "collapse-container"}>
          <div className="card-body">
            <div className="input-group">
              <span className="input-group-text">Email</span>
              <input className="form-control" type="email" value={user?.email || ""} placeholder="nom@exemple.fr" onChange={(event) => {
                onChange({
                  ...user,
                  email: event.target.value,
                })
              }} />
            </div>
            {(formUpdated || !isExistingUser) && (
              <div className="actions">
                <button className="bo-primary-action" type="button" onClick={saveForm}><span className="fas fa-save"></span>Enregistrer</button>
                {isExistingUser && <button className="bo-secondary-action" type="button" onClick={resetForm}>Annuler</button>}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
